import { Models } from "api/types";
import { Icon } from "atoms/icon/Icon";
import ChevronRight from "atoms/icon/icons/chevron_right.svg";
import { ImagePlaceholder } from "atoms/image-placeholder/ImagePlaceholder";

interface Props {
  platformLocations: Models<"GetMultiPlatformLocationsResult">[];
  onItemClick: (platformId: string, locationId: string) => void;
}

export const PlatformWithLocationsList = ({
  platformLocations,
  onItemClick,
}: Props) => {
  if (!platformLocations.length) {
    return null;
  }

  return (
    <ul className="flex flex-col">
      {platformLocations.map((platformLocation) => {
        const platformImageUrl = platformLocation.platformImageUrl;
        const platformName = platformLocation.platformName;

        const rawDistance = platformLocation.distance ?? 0;
        const roundedDistance = Math.round(rawDistance * 10) / 10;
        const showDistance = roundedDistance > 0;

        return (
          <li
            key={platformLocation.id}
            onClick={() => {
              onItemClick(platformLocation.platformId, platformLocation.id);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onItemClick(platformLocation.platformId, platformLocation.id);
              }
            }}
            tabIndex={0}
            role="button"
            aria-label={`Select ${platformName || "location"}`}
            className="flex cursor-pointer items-center gap-4 rounded-lg bg-white py-2"
          >
            <ImagePlaceholder
              className="rounded"
              url={platformImageUrl}
              title={platformName}
              size="sm"
            />
            <div className="flex-1">
              {platformName && <div className="text-body1">{platformName}</div>}
              <div className="text-body3">
                {showDistance && (
                  <span>
                    {roundedDistance}mi
                    {platformLocation.platformLocationName &&
                      platformLocation.platformLocationName !==
                        platformName && <span className="mx-1">•</span>}
                  </span>
                )}
                {platformLocation.platformLocationName &&
                  platformLocation.platformLocationName !== platformName && (
                    <span>
                      {platformLocation.platformLocationName}
                      <span className="mx-1">-</span>
                    </span>
                  )}
                <span className="text-secondary">
                  {platformLocation.address1}, {platformLocation.postalCode}
                </span>
              </div>
            </div>

            <Icon svg={ChevronRight} size="x2small" color="brandColor" />
          </li>
        );
      })}
    </ul>
  );
};
